 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~9a7cfb37","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f1a6f51d","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~c810e73c","4":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~8df6e383","7":"source~bet-details-page~betting-history-page","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-es-cl-json","10":"source~i18n-widgets-es-json","11":"source~i18n-widgets-es-mx-json","12":"source~i18n-widgets-es-pe-json","13":"source~i18n-widgets-pt-json","16":"source~/esports-betting-rules-TR","17":"source~bet-builder-rules-AZ","18":"source~bet-builder-rules-DE","19":"source~bet-builder-rules-EN","20":"source~bet-builder-rules-ES","21":"source~bet-builder-rules-ES-MX","22":"source~bet-builder-rules-ET","23":"source~bet-builder-rules-FI","24":"source~bet-builder-rules-FR","25":"source~bet-builder-rules-IT","26":"source~bet-builder-rules-JA","27":"source~bet-builder-rules-KA","28":"source~bet-builder-rules-LT","29":"source~bet-builder-rules-LV","30":"source~bet-builder-rules-PL","31":"source~bet-builder-rules-PT-BR","32":"source~bet-builder-rules-RO","33":"source~bet-builder-rules-RU","34":"source~bet-builder-rules-SQ","35":"source~bet-builder-rules-SV","36":"source~bet-builder-rules-TR","37":"source~bet-details-page","38":"source~betting-history-container","39":"source~betting-history-page","40":"source~betting-rules-AZ","41":"source~betting-rules-DA","42":"source~betting-rules-DE","43":"source~betting-rules-EN","44":"source~betting-rules-ES","45":"source~betting-rules-ES-MX","46":"source~betting-rules-FR","47":"source~betting-rules-IT","48":"source~betting-rules-JA","49":"source~betting-rules-PL","50":"source~betting-rules-PT","51":"source~betting-rules-PT-BR","52":"source~betting-rules-RO","53":"source~betting-rules-RU","54":"source~betting-rules-SQ","55":"source~betting-rules-SV","56":"source~betting-rules-TR","57":"source~bonus-info","58":"source~cashout-terms-AR","59":"source~cashout-terms-AZ","60":"source~cashout-terms-DA","61":"source~cashout-terms-DE","62":"source~cashout-terms-EN","63":"source~cashout-terms-ES","64":"source~cashout-terms-ES-MX","65":"source~cashout-terms-ET","66":"source~cashout-terms-FI","67":"source~cashout-terms-FR","68":"source~cashout-terms-IT","69":"source~cashout-terms-JA","70":"source~cashout-terms-KA","71":"source~cashout-terms-KU","72":"source~cashout-terms-LT","73":"source~cashout-terms-LV","74":"source~cashout-terms-PL","75":"source~cashout-terms-PT","76":"source~cashout-terms-PT-BR","77":"source~cashout-terms-RO","78":"source~cashout-terms-RU","79":"source~cashout-terms-SQ","80":"source~cashout-terms-SR","81":"source~cashout-terms-SV","82":"source~cashout-terms-TR","83":"source~esports-betting-rules-AZ","84":"source~esports-betting-rules-DA","85":"source~esports-betting-rules-DE","86":"source~esports-betting-rules-EN","87":"source~esports-betting-rules-ES","88":"source~esports-betting-rules-ES-MX","89":"source~esports-betting-rules-ET","90":"source~esports-betting-rules-FI","91":"source~esports-betting-rules-FR","92":"source~esports-betting-rules-IT","93":"source~esports-betting-rules-JA","94":"source~esports-betting-rules-KA","95":"source~esports-betting-rules-LT","96":"source~esports-betting-rules-LV","97":"source~esports-betting-rules-PL","98":"source~esports-betting-rules-PT","99":"source~esports-betting-rules-PT-BR","100":"source~esports-betting-rules-RO","101":"source~esports-betting-rules-RU","102":"source~esports-betting-rules-SQ","103":"source~esports-betting-rules-SR","104":"source~esports-betting-rules-SV","105":"source~generated-mappings","106":"source~i18n-en-json","107":"source~i18n-es-cl-json","108":"source~i18n-es-json","109":"source~i18n-es-mx-json","110":"source~i18n-es-pe-json","111":"source~i18n-pt-json","113":"source~settings-page","114":"source~streaming-carousel","115":"source~virtual-esports-betting-rules-AZ","116":"source~virtual-esports-betting-rules-EN","117":"source~virtual-esports-betting-rules-IT","118":"source~virtual-esports-betting-rules-JA","119":"source~virtual-esports-betting-rules-PL","120":"source~virtual-esports-betting-rules-RU","122":"vendors~rc-slider","123":"vendors~react-google-recaptcha","124":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"cfd7872317651b28c283","1":"e7362177e5b438f6ae14","2":"9a3e64bb6c398b1145a4","3":"52eb989790f4ab49c428","4":"8f254462344aff9ceb0a","5":"749c8206e81ae34dba4e","6":"59bf206960d88fc5e50b","7":"a92126ea4bcd22a5667f","8":"a0c1c8322b3e802f69a6","9":"ae3b7ae3b331a37753f9","10":"98c5abd0fe35790f48cb","11":"21f3f1ad85cc91a3091a","12":"4bd1ab7343a5866e8322","13":"0947c89f8fa9e962fd59","16":"2c0965ab5e241ecfeb13","17":"a01904a385fda73f13e2","18":"f0b471accaf51034b482","19":"546cb9cd2fdc4d1998b9","20":"e250b72f2025ddf9c9a2","21":"becff51950cfa9265f3f","22":"ced0c2fc04713be2d531","23":"83f1d0f1e8cb0b4a18bc","24":"5cf11f1f6a3f65151f7f","25":"109c4b3f5dd06836d311","26":"784e443251db5418b72b","27":"3f51f8f45c82468dc875","28":"b7c2fbaf04b0c96d635a","29":"a87089d3a0842e370d2f","30":"538ce777a5cb56ccd8e6","31":"28c77b24d86253af2f7d","32":"e0db175c1caf86ed2846","33":"685f77662961c8d3f8da","34":"8d33c82e927d0e057491","35":"82193707f28a01de91cf","36":"7fd5b3fec36843fe79bd","37":"b97a3023dcc7f0026234","38":"3ee6e10b8f35f1c89bb2","39":"feecffc6f4ca1979cdf2","40":"36d593d4fa43ec5f25bb","41":"e57e8a25c0308c8ff88e","42":"a6fe711dff485ce7e7d1","43":"6861adbedfaf61427adb","44":"9f037f8b84b3de90cd21","45":"0922a720ae68067d7ece","46":"8839f345e47dee3e269f","47":"64ee05bc942483d17739","48":"fa5f6979266f6475c927","49":"9dbf500f35829bc8f6c1","50":"67a48dbff4c09edafb8f","51":"b0ac48b3638f5172395b","52":"f79474ea1ce76539b770","53":"8d2a16b788d670ef6823","54":"e99e575c2381634ff271","55":"460b6b1c3279b465caa7","56":"8b62ecef93179041b95f","57":"05ce54a11c767efcd93b","58":"d6ece40ba2f9c5b7194c","59":"36ed33876f1495a9393f","60":"fe68dfb703555a947fc9","61":"3f8a01dd495f9c6511cf","62":"145fedb766ce718a7fa8","63":"dd37d48ec60138da3c44","64":"657d884ae41b370deeab","65":"46f60b368d9ea8a80e64","66":"255fcc667e5607253b1a","67":"dabf23917f208fb85e58","68":"3ff470d4e3bdce757da0","69":"7e7ed084095faacdab24","70":"86b90d42883697e1e624","71":"0d8a15fa098ea9921979","72":"47728d09c241382a1744","73":"dea2e98f1243b49c059c","74":"95985d18ed6dcdcd25f2","75":"467ff898f4806b3f395a","76":"ad8f01557bf3e76ef721","77":"ea5b6f8b20e69a5ecfcc","78":"7654693c0ea7752af33e","79":"e3bf0565d4ed630baecc","80":"396a2bd259aa149dde72","81":"0874bf4405547927cc38","82":"81f5152d743ae1f8e88c","83":"8eb4c3988a7689385266","84":"965c15a5aa3ec399bd1a","85":"5e4c511699983fd00ed4","86":"31af8bfab5381f3f925a","87":"e6a3979bd53bb587e1d2","88":"198ff954a089ff583d29","89":"8a07f334bb209f811775","90":"fbf3420deb5b93d731ea","91":"355c36a7dccd7be52e05","92":"fc9cf87cfc542f297733","93":"177cb75ed5fda0596046","94":"a602b9eeea60aab64c63","95":"56090f361efc772ced1e","96":"87153f61f31484c55c0d","97":"3ae05d7328930595c37f","98":"0dfa40d2be62aa0d6702","99":"e3890e905acd464fe57b","100":"3e653722c70de526bafa","101":"1eb804e4ef6c6db9be0b","102":"740d96867dde79d9e001","103":"58070a6d44d8e5caba36","104":"2dcd41c68d27a77d5c21","105":"6a913b42e12ffca87b2a","106":"7ebd8390fd601fbdc6b7","107":"45c245e9ce61e002bae1","108":"819d74d776136310d70c","109":"04dcc93a143e231b35f2","110":"4cb0a34c5b90c86e70d2","111":"64cd4c1524d00f86a5ca","113":"cb8785b034dccf8112c9","114":"e084af81b2c5337732b7","115":"dfc77be094fe36eafac7","116":"e115c4c02aae48bb272f","117":"bf26555041aaf47df3fb","118":"1098ff0e9f33d6818084","119":"8771bd2f8c1930312ef7","120":"e12102c2957ed5fcf510","122":"2bb1fb6e00fbc2821321","123":"693aafce1993068282e0","124":"b9d5f98fc58d1072e62a","125":"d2fcb1497d15c3209963","126":"7518e8961bcb0d873758","127":"091bc1df21c7e83be1f1","128":"093ec45bef13c87026ba","129":"a2cc05673100438c8ff3","130":"0e84c7ff40f4d3e7e6c5","131":"0790522a2321bba2541c","132":"d1043576b3bbcdc78b73","133":"57ab52c0f350db8db34c","134":"8293c32b7bd444f8a26c","135":"e638339f1321d219d75f","136":"186b47c44c76e8d18586","137":"81a86f31e57765aefb35","138":"f12adee355c55e7687b2","139":"a749b716051e5362ac0d","140":"1973ea1f28a319ba0c79","141":"599df6351dfd0ca9c97b","142":"79092ab08812475d099d","143":"ffd7542d402808ca2e05","144":"4f52c0a70d5c0f9e2439","145":"b41328a34034061a5472","146":"564ad4e4f93b7bb1dc4e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
